import { z } from "zod";

const DailyDataSchema = z.object({
    date: z.string(), // Assuming ISO date format
    total_rooms: z.number(),
    total_booked: z.number(),
    occupancy: z.number(),
    available: z.number(),
    total_revenue: z.union([z.string(), z.number()]), // Handling both string and number cases
    adr: z.number(),
    revpar: z.number(),
    revpar_room_only: z.number(),
    total_revenue_with_extra: z.number()
});

const TotalSchema = z.object({
    total_rooms: z.number(),
    total_booked: z.number(),
    occupancy: z.number(),
    available: z.number(),
    total_revenue: z.number(),
    adr: z.number(),
    revpar: z.number(),
    revpar_room_only: z.number(),
    total_revenue_with_extra: z.number()
});

export const DailyResponseSchema = z.object({
    success: z.boolean(),
    message: z.string(),
    code: z.number(),
    data: z.array(DailyDataSchema),
    total: TotalSchema
});

export type DailyResponse = z.infer<typeof DailyResponseSchema>;